import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=33d2f04e&scoped=true&"
import script from "./layout.vue?vue&type=script&lang=js&"
export * from "./layout.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./layout.vue?vue&type=style&index=0&id=33d2f04e&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "33d2f04e",
  "6f7c8bbd"
  
)

component.options.__file = "layout.vue"
export default component.exports